import React from "react"
import Reporticon from "../../../assets/images/document_accept.svg"
import Imageicon from "../../../assets/images/image_images.svg"
const TableAction = ({ handleOnExpand, handleVerify, cellProps }) => {
  return (
    <div>
      <span data-hover="Active Summary">
        <img
          src={Reporticon}
          alt={Reporticon}
          style={{ cursor: "pointer" }}
          onClick={() => handleOnExpand(cellProps?.row.original)}
        />
      </span>
      <span data-hover="Verify Screens" className="mx-2">
        <img
          src={Imageicon}
          style={{ cursor: "pointer", zIndex: "999" }}
          alt={Imageicon}
          onClick={() => handleVerify(cellProps?.row.original)}
        />
      </span>
    </div>
  )
}

export default TableAction
